import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { VBox } from "../../../components/Box";
import { FormField } from "../../../components/FormFields";
import { Dropdown } from "../../../components/Dropdown";
import { BmpResult } from "./BmpResult";

const STATE = {
    selectedRegime: null,
};

/* eslint-disable react/prefer-stateless-function */
class BpmResultContainerComp extends BaseComponent {
    constructor(props) {
        super(props, {
            ...STATE,
        });
    }

    get regimes() {
        let regimes = [];
        if (!this.props?.result) return regimes;
        let preferredRegime = this.props?.result;

        if (preferredRegime.error) {
            return [preferredRegime];
        }

        regimes.push({
            ...preferredRegime,
            preferred: true,
            label: `${this.generateOptionLabel(preferredRegime)} - Preferred`,
            key: preferredRegime.bpmRegime + '_' + preferredRegime.emissionMeasurement,
        });

        if (preferredRegime?.alternativeCalculations && preferredRegime?.alternativeCalculations.length) {
            for (let r of preferredRegime.alternativeCalculations) {
                regimes.push({
                    ...r,
                    preferred: false,
                    label: this.generateOptionLabel(r),
                    key: r.bpmRegime + '_' + r.emissionMeasurement,
                });
            }
        }

        return regimes;
    }

    get regimeOptions() {

        return this.regimes.map(r => {

            return {
                label: r.label,
                value: r.key,
            };
        });
    }

    get selectedRegimeKey() {

        return this.state.selectedRegime ?? this.preferredRegime?.key ?? null;
    }

    get selectedRegime() {
        let selected = this.regimes.find(r => r.key === this.selectedRegimeKey);
        if (!selected) {
            selected = this.regimes[0];
        }

        return selected;
    }

    get preferredRegime() {

        return this.regimes.find(r => r.preferred);
    }

    regimeChanged(evt) {
        const key = evt.value;
        this.setState((prev, props) => {
            return {...prev, selectedRegime: key};
        });
        return this;
    }

    generateOptionLabel(regime) {
        let label = regime.bpmRegime;
        if (regime.emissionMeasurement) {
            label += `(${regime.emissionMeasurement})`;
        }

        return label;
    }

    generateOptionKey(regime) {
        let key = regime.bpmRegime;
        if (regime.emissionMeasurement) {
            key += `_(${regime.emissionMeasurement})`;
        }

        return key;
    }


    renderDropdown() {

        return (
            this.regimes.length > 1 &&
            <VBox>
                <p>{this.lbl('tools.bpm.result.regime')}</p>
                <FormField>
                    <Dropdown options={this.regimeOptions}
                              onChange={this.regimeChanged.bind(this)}
                              value={this.selectedRegimeKey}/>
                </FormField>
            </VBox>
        );
    }

    render() {
        return (
            this.regimes.length > 0 &&
            <div>
                {this.renderDropdown()}
                <BmpResult result={this.selectedRegime} />
            </div>
        );
    }
}

BpmResultContainerComp.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
    createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatch,
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export const BpmResultContainer = compose(
    withConnect,
    withRouter,
)(BpmResultContainerComp);
